import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import api from "../../services/AxiosInstance";

// GET /api/reports/house-list
export const fetchHouseListReportThunk =
  createAsyncThunk(
    "reports/houseList",

    async (
      filters = {},
      { rejectWithValue },
    ) => {
      try {
        const params = {
          ward_id:
            filters?.ward_id || "",

          mtr_type:
            filters?.mtr_type || "",

          slrm_type:
            filters?.slrm_type || "",

          search:
            filters?.search || "",

          page: Number(
            filters?.page || 1,
          ),

          pageSize: Number(
            filters?.pageSize || 20,
          ),

          ...(filters?.sort_field
            ? {
                sort_field:
                  filters.sort_field,

                sort_direction:
                  String(
                    filters?.sort_direction ||
                      "",
                  ).toLowerCase() ===
                  "asc"
                    ? "asc"
                    : "desc",
              }
            : {}),

          export:
            Number(filters?.export) === 1
              ? 1
              : 0,
        };

        const response = await api.get(
          "/api/reports/house-list",
          {
            params,
          },
        );

        if (!response.data?.success) {
          return rejectWithValue(
            response.data?.message ||
              "Failed to load House List report",
          );
        }

        return response.data;
      } catch (error) {
        return rejectWithValue(
          error?.response?.data?.message ||
            error?.message ||
            "Server error",
        );
      }
    },
  );

const houseListReportSlice =
  createSlice({
    name: "houseListReport",

    initialState: {
      rows: [],
      meta: {},
      loading: false,
      error: null,
    },

    reducers: {
      clearHouseListReport: (state) => {
        state.rows = [];
        state.meta = {};
        state.loading = false;
        state.error = null;
      },
    },

    extraReducers: (builder) => {
      builder
        .addCase(
          fetchHouseListReportThunk.pending,
          (state, action) => {
            const isExport =
              Number(
                action.meta.arg?.export,
              ) === 1;

            // Export should not disturb
            // the current table loading state.
            if (isExport) {
              return;
            }

            state.loading = true;
            state.error = null;
          },
        )

        .addCase(
          fetchHouseListReportThunk.fulfilled,
          (state, action) => {
            const isExport =
              Number(
                action.meta.arg?.export,
              ) === 1;

            // Export response is obtained
            // using dispatch(...).unwrap().
            if (isExport) {
              return;
            }

            state.loading = false;

            state.rows =
              action.payload?.data || [];

            state.meta =
              action.payload?.meta || {};

            state.error = null;
          },
        )

        .addCase(
          fetchHouseListReportThunk.rejected,
          (state, action) => {
            const isExport =
              Number(
                action.meta.arg?.export,
              ) === 1;

            // Export errors are handled
            // inside Excel/PDF functions.
            if (isExport) {
              return;
            }

            state.loading = false;

            state.error =
              action.payload ||
              action.error?.message ||
              "Failed to load House List report";
          },
        );
    },
  });

export const {
  clearHouseListReport,
} = houseListReportSlice.actions;

export default houseListReportSlice.reducer;